<template>
  <div>
    <b-button variant="light"  v-b-modal.importKmlModal>{{$t('IMPORT_KML_LABEL')}}</b-button>

    <b-modal id="importKmlModal" scrollable>
      <b-form-file accept="txt/kml" v-model="kmlFile" />

              <template #modal-footer="{cancel}">
                <b-button @click="cancel()">
                  {{ $t('MODAL_CLOSE_LABEL') }}
                </b-button>
                <b-button @click="importKML(cancel)">
                  {{ $t('MODAL_IMPORT_LABEL') }}
                </b-button>
              </template>

            </b-modal>

  </div>
</template>

<script>

import { ref } from '@vue/composition-api'
import { BFormFile, BButton, VBModal } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import './L.KML.js'

export default {
  props: { 
    value: { required: true }
  },
  emits: ['update:value'],
  components: { BFormFile, BButton, VBModal },
  directives: { Ripple },
  setup(props, { root, emit }) {

    const kmlFile = ref(null)

    const importKML = (cancel)=> {

        if(kmlFile.value != null){
          kmlFile.value.arrayBuffer().then(((data)=> {
          let layer = new L.LayerGroup(L.KML.parseKML(new DOMParser().parseFromString(new TextDecoder().decode(data), 'text/xml')))
          props.value.addLayer(layer)
          emit('update:value', props.value )
        }))
        kmlFile.value = null
        cancel()
        

      }
    }

    return {kmlFile, importKML}

  }
}
</script>
<style scoped>

.kml-file-input:lang(en) ~ .kml-file-input:lang::after {
  content: 'Import KML';
}

</style>
